import { ListViolations } from "@/graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";

export const GetAllViolations = {
  data() {
    return {
      GetAllViolationsList: [],
      overlay: false,
      user_type: "",
      ViolationsList: [],
    };
  },
  methods: {
    async GetAllViolationsMethod() {
      try {
        this.loading = true;
        this.overlay = true;
        this.hasaccessRoutesList = [];
        let result = await API.graphql(
          graphqlOperation(ListViolations, {
            input: {},
          })
        );

        this.ViolationsList = JSON.parse(result.data.ListViolations).data.items;
        this.GetAllViolationsList = this.ViolationsList.filter(
          (item) => item.violation_status === "ACTIVE"
        );
        this.loading = false;
        this.overlay = false;
        if (this.$store.getters.get_current_user_details.favourite_violations) {
          this.SelectedViolation =
            this.$store.getters.get_current_user_details.favourite_violations.filter(
              (item) =>
                this.GetAllViolationsList.some(
                  (list) => list.violation_id === item.violation_id
                )
            );
        }
        return this.GetAllViolationsList;
      } catch (error) {
        console.log("Check error", error);
        this.loading = false;
        this.overlay = false;
        this.$router.push("/");
        return "ERROR";
      }
    },
  },
};
